// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"cW","header":"cX","copy":"cY","formLabel":"cZ","dismissModal":"c0","buttonRow":"c1","buttonWrapper":"c2","button":"c3"};